<template>
  <div>
    <div class="success-header">
      <h2 class="success-header-title">
        ¡Ya tenes tu <span>reserva</span>!
      </h2>
      <h3 class="success-header-subtitle">
        Tu reserva ha sido confirmada según tu solicitud:
      </h3>
    </div>
    <div class="success">
      <div>
        <table class="tbl mb-0">
          <tr>
            <th class="txt-left">
              TARIFA
            </th>
            <th class="txt-left">
              BASE / BUS
            </th>
            <th>PASAJERO</th>
            <th>DNI</th>
            <th class="txt-right">
              <span class="span-ceara">PRECIO</span>
            </th>
          </tr>
          <tr
            v-for="(pax, i) in passengers"
            :key="i"
          >
            <td class="txt-left">
              <span>{{ rate.detail }}</span>
            </td>
            <td class="txt-left">
              <span v-if="pax.fee_es && pax.seat_categ_str">
                {{ pax.fee_es }} / {{ pax.seat_categ_str }}
              </span>
            </td>
            <td>
              {{ pax.alt }}
              <small v-if="pax.main"><strong>(titular)</strong></small>
            </td>
            <td>{{ pax.ident || '-' }}</td>
            <td class="txt-right">
              {{ price.currency }}{{ pax.price || ' -' }}
            </td>
          </tr>
          <tr v-if="price.insurance_outland">
            <td colspan="4">
              COBERTURA MEDICA EXTERIOR
            </td>
            <td>{{ price.currency + price.insurance_outland }}</td>
          </tr>
          <tr v-if="price.insurance_old">
            <td
              class="text-left"
              colspan="4"
            >
              COBERTURA MEDICA MAYORES DE {{ $parent.departure.insurance.age }}
            </td>
            <td class="txt-right">
              {{ price.currency + price.insurance_old }}
            </td>
          </tr>
        </table>
        <table class="tbl">
          <tr v-if="price.promo_discount || price.service_discount">
            <th
              class="txt-left"
              colspan="6"
            >
              DESCUENTOS
            </th>
          </tr>
          <tr v-if="price.promo_discount">
            <td
              class="txt-left"
              colspan="5"
            >
              {{ price.promo_description }}
            </td>
            <td class="txt-right">
              {{ price.currency }}{{ price.promo_discount }}
            </td>
          </tr>
          <tr v-if="price.service_discount">
            <td
              class="txt-left"
              colspan="5"
            >
              {{ price.service_description }}
            </td>
            <td class="txt-right">
              {{ price.currency }}{{ price.service_discount }}
            </td>
          </tr>
          <tr>
            <th
              colspan="6"
              class="txt-right"
            >
              <span class="mr-3">SUBTOTAL</span>
              {{ price.currency }}{{ price.subtotal }}
            </th>
          </tr>
          <tr>
            <td
              class="txt-left"
              colspan="5"
            >
              COMISIÓN AGENCIA
            </td>
            <td class="txt-right">
              {{ price.currency }}{{ price.commission }}
            </td>
          </tr>
          <tr>
            <td
              class="txt-left"
              colspan="5"
            >
              GASTOS BANCARIOS
            </td>
            <td class="txt-right">
              {{ price.currency }}{{ price.bank_taxes }}
            </td>
          </tr>
        </table>
        <table class="tbl">
          <tr>
            <th class="txt-left">
              DESTINO
            </th>
            <th>RESERVA</th>
            <th>CANT. PASAJEROS</th>
            <th>SEÑA</th>
            <th>VENCIMIENTO</th>
            <th class="txt-right">
              <span class="span-ceara">TOTAL</span>
            </th>
          </tr>
          <tr>
            <td class="txt-left">
              {{ departure.alias }} {{ departure.name }}
            </td>
            <td>{{ price.reservation_id }}</td>
            <td>{{ passengers.length }}</td>
            <td>{{ price.currency }}{{ price.partial }}</td>
            <td>{{ expiration }}</td>
            <td class="txt-right">
              <strong>{{ price.currency }}{{ price.final }}</strong>
            </td>
          </tr>
        </table>
      </div>
      <div class="success-footer mb-3">
        <p class="success-msg">
          Podes realizar el pago de la seña con tarjeta de credito mediante nuestra
          plataforma de pagos online, o bien contactarte con administración por otras
          formas de pagos.
        </p>
        <btn
          color="white"
          size="xs"
          @click="$emit('close')"
        >
          CERRAR
        </btn>
        <btn
          color="black"
          size="xs"
          href="http://cearaevt.tur.ar/shop/variable/"
          target="_blank"
        >
          PAGO ONLINE
        </btn>
        <btn
          color="orange"
          size="xs"
          @click="print"
        >
          IMPRIMIR
        </btn>
      </div>
    </div>
  </div>
</template>
<script>
import { search, yyyymmdd_ddmmyyy } from '@/utils'
import Btn from '@/components/Btn'

export default {
  name: 'Success',

  props: ['departure'],

  components: { Btn },

  computed: {
    expiration () {
      return yyyymmdd_ddmmyyy(this.$store.state.booking.price.expiration)
    },
    rate () {
      return this.$store.state.booking.rate
    },
    price () {
      return this.$store.state.booking.price
    },
    passengers () {
      return this.$store.state.booking.passengers
    }
  },

  methods: {
    print () {
      window.print()
    }
  }
}
</script>
